import { AgePipe } from '@web/csl-lib-pipes';
import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'csl-patient-banner',
  standalone: true,
  imports: [CommonModule, AgePipe],
  templateUrl: './patient-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './patient-banner.component.css',
})
export class PatientBannerComponent {
  patientLastFirstName = input.required<string | null | undefined>();
  patientDateOfBirth = input.required<Date | null | undefined>();
}
